<template>
  <fieldset class="flex gap-16">
    <RevInputText
      id="backbox-price-min-range"
      v-model="backboxPriceMinRangeValue"
      :label="i18n(sharedTranslations.backboxPriceRangeTypeMin)"
      min="0"
      type="number"
    />

    <RevInputText
      id="backbox-price-max-range"
      v-model="backboxPriceMaxRangeValue"
      :label="i18n(sharedTranslations.backboxPriceRangeTypeMax)"
      type="number"
    />
  </fieldset>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputText } from '@ds/components/InputText'

import sharedTranslations from '../../../Filters.translations'
import type { InitialFilterValues } from '../../../Filters.types'

const i18n = useI18n()

const backboxPriceMinRangeValue = defineModel<
  InitialFilterValues['backboxPriceMinRange']
>('backboxPriceMinRangeValue')
const backboxPriceMaxRangeValue = defineModel<
  InitialFilterValues['backboxPriceMaxRange']
>('backboxPriceMaxRangeValue')
</script>
